module.exports = __webpack_public_path__ + "img/big4-11.58fe4d60.jpg";